export default (str) =>
// eslint-disable-next-line
str.replace(/["\s]/g,' ');
